import { createIcon } from '@consta/icons/Icon'
import type { SVGProps } from 'react'

function IconActiveFolderM(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M2.16667 2.625C1.52233 2.625 1 3.19584 1 3.9V14.1C1 14.8042 1.52233 15.375 2.16667 15.375H13.8333C14.4777 15.375 15 14.8042 15 14.1V5.175C15 4.47084 14.4777 3.9 13.8333 3.9H6.83333C6.83333 3.19584 6.311 2.625 5.66667 2.625H2.16667Z"
        fill="#32B4FF"
      />
    </svg>
  )
}
export const IconActiveFolder = createIcon({
  l: IconActiveFolderM,
  m: IconActiveFolderM,
  s: IconActiveFolderM,
  xs: IconActiveFolderM,
  name: 'IconActiveFolder',
})
